var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "standart_mem clr" },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c("h1", { staticClass: "title text-center pt-5 pb-5 mt-5" }, [
            _vm._v(_vm._s(_vm.title) + " "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "quest" }, [
            _vm._v("щодо\n            "),
            _c("span", [_vm._v(_vm._s(_vm.quest_title))]),
          ]),
          _vm._v(" "),
          _vm.is_active_title
            ? _c(
                "b-row",
                { staticClass: "doc_title" },
                [
                  _c("b-col", { attrs: { sm: "3" } }, [
                    _c("label", { attrs: { for: "doc_title" } }, [
                      _vm._v("тема (коротка назва) *"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "6" } },
                    [
                      _c("b-form-input", {
                        staticClass: "fs-xl",
                        attrs: {
                          state: _vm.is_valid_title,
                          maxlength: "255",
                          id: "doc_title",
                          size: "sm",
                        },
                        model: {
                          value: _vm.mem_title,
                          callback: function ($$v) {
                            _vm.mem_title = $$v
                          },
                          expression: "mem_title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("after_title"),
          _vm._v(" "),
          _vm._t("mem_preamblua", function () {
            return [
              _vm.is_active_preamblua
                ? _c(
                    "b-row",
                    { staticClass: "mem_create_row" },
                    [
                      _c("b-col", { attrs: { sm: "3" } }, [
                        _c("label", [_vm._v("преамбула")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { sm: "9" } },
                        [
                          _c("vue-editor", {
                            attrs: {
                              "editor-toolbar": _vm.editor_rules,
                              id: "preamblua",
                            },
                            model: {
                              value: _vm.mem_preamblua,
                              callback: function ($$v) {
                                _vm.mem_preamblua = $$v
                              },
                              expression: "mem_preamblua",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _vm.is_active_problem
            ? _c(
                "b-row",
                { staticClass: "mem_create_row" },
                [
                  _c("b-col", { attrs: { sm: "3" } }, [
                    _c("label", [_vm._v("проблема")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "9" } },
                    [
                      _c("vue-editor", {
                        attrs: {
                          "editor-toolbar": _vm.editor_rules,
                          id: "problem",
                        },
                        model: {
                          value: _vm.mem_problem,
                          callback: function ($$v) {
                            _vm.mem_problem = $$v
                          },
                          expression: "mem_problem",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_active_result
            ? _c(
                "b-row",
                { staticClass: "mem_create_row" },
                [
                  _c("b-col", { attrs: { sm: "3" } }, [
                    _c("label", [_vm._v("запропоноване рішення")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "9" } },
                    [
                      _c("vue-editor", {
                        attrs: {
                          "editor-toolbar": _vm.editor_rules,
                          id: "result",
                        },
                        model: {
                          value: _vm.mem_result,
                          callback: function ($$v) {
                            _vm.mem_result = $$v
                          },
                          expression: "mem_result",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "doc_title" },
            [
              _c("b-col", { attrs: { sm: "3" } }, [
                _c("label", { attrs: { for: "reason_number" } }, [
                  _vm._v("документ підстава (при наявності)"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "6" } },
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        multiple: "",
                        label: "number",
                        filterable: false,
                        options: _vm.multi_reasons,
                      },
                      on: { search: _vm.onSearch, input: _vm.push_reason_str },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function (option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.number) +
                                    "\n                            "
                                ),
                                _c("small", [_vm._v(_vm._s(option.title))]),
                              ]),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.active_reasons,
                        callback: function ($$v) {
                          _vm.active_reasons = $$v
                        },
                        expression: "active_reasons",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                        Починайте вводити номер службової\n                    "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }